import React from "react";
import {NavLink} from "react-router-dom";
import Layout from "../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEarthEurope,
  faNewspaper,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

import {WBGLogoWhite, ESMAPLogoWhite, VidaLogoWhite, LandingPage} from "../components/Images";

export default function Home() {

  return (
    <Layout>
     <Helmet>
       <title>Distributed Renewable Energy (DRE) Atlas - Home</title>
       <meta name="description" content="Explore comprehensive datasets on communities across 58 countries from Sub-Saharan Africa, Asia & the Pacific, and Latin America & the Caribbean to enable informed investment decisions." />
     </Helmet>
      <section className="home-hero-section">
        <div className="home-text-column text-white">
          <header>
            <h4 className="text-uppercase text-white">Welcome to the</h4>
            <h1 className="fw-bolder text-yellow">Distributed Renewable Energy (DRE) Atlas</h1>
            <h2 className="text-white">Planning Platform</h2>
          </header>
          <article id="home-description-section">
            <h5>Explore comprehensive datasets on communities across 58 countries from Sub-Saharan Africa, Asia & the Pacific, and Latin America & the Caribbean to enable informed investment decisions.</h5>
          </article>
          <div id="home-button-section">
            <a className="btn btn-yellow" href="/countries">EXPLORE</a>
            <a className="btn btn-navy-blue ms-3" href="/about">ABOUT</a>
          </div>
        </div>

        <div className="home-image-column">
          <img
            alt="Illustration of diverse communities and global connections"
            src={LandingPage}
            className="home-landing-image"
          />
        </div>
        
        <div id="home-logo-section"> 
        <img
          alt="ESMAP Logo"
          src={ESMAPLogoWhite}
          className="img-fluid bottom-logo"
        />
        <img
          alt="World Bank Group Blue Logo"
          src={WBGLogoWhite}
          className="img-fluid bottom-logo-wbg"
        />
        <img
          alt="World Bank Group Blue Logo"
          src={VidaLogoWhite}
          className="img-fluid bottom-logo-vida"
        />
      </div>
      </section>
      
    </Layout>
  );
}
